;(() => {
  const productTemplate = document
    .querySelector('html')
    .classList.contains('template-product')

  if (productTemplate) {
    const scrollToButtons = document.querySelectorAll('button[data-scroll-to]')

    function isVisible(element) {
      return !!(
        element.offsetWidth ||
        element.offsetHeight ||
        element.getClientRects().length
      )
    }

    scrollToButtons.forEach((button) => {
      button.addEventListener('click', () => {
        document
          .querySelectorAll(
            `[data-scroll-anchor-name="${button.getAttribute(
              'data-scroll-to'
            )}"]`
          )
          .forEach((element) => {
            if (isVisible(element)) {
              element.scrollIntoView({ behavior: 'smooth' })
              element.click()
            }
          })
      })
    })

    const bulbsToggle = document.querySelector('#bulbs-toggle')
    if (bulbsToggle) {
      bulbsToggle.addEventListener('click', function () {
        this.querySelector('.btn-plus').classList.toggle('active')
        const panel = this.nextElementSibling
        if (!panel.style.maxHeight || panel.style.maxHeight !== '0px') {
          panel.style.maxHeight = 0
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px'
        }
      })
    }

    const productFullscreenImages = document.querySelector(
      '.product-fullscreen-images'
    )
    const htmlElement = document.documentElement

    //open fullscreen images modal and scroll to relevant image
    document
      .querySelectorAll(
        '.swiper-product .swiper-slide[data-media-type="image"], .product-images-grid figure[data-media-type="image"]'
      )
      .forEach((slide) => {
        slide.addEventListener('click', () => {
          const mediaId = slide.getAttribute('data-media-id')
          productFullscreenImages.classList.add('active')
          const relevantImage = productFullscreenImages.querySelector(
            `#media-id-${mediaId}`
          )
          relevantImage.scrollIntoView()
          htmlElement.classList.add('fullscreen-product-images-open')
        })
      })

    //click anywhere to close product fullscreen images
    productFullscreenImages.addEventListener('click', () => {
      productFullscreenImages.classList.remove('active')
      htmlElement.classList.remove('fullscreen-product-images-open')
    })
  }
})()
